class BatchingTableController {
  constructor($rootScope, $scope, $timeout, Batching, Constants, ngDialog) {
    Object.assign(this, {
      $scope,
      $timeout,
      Constants,
      Batching,
      ngDialog,
      visits: [],
      pagination: {
        limit: 50,
        offset: 0,
        sort: 'default',
        order: 'desc',
        search: '',
        timezone: $rootScope.timezones[0].timezone,
        category_code: "MAP-F",
      },
      categories: [],
      activeCategory: null,
      subscriptions: new Map(),
      batchCount: 0,
      checkboxStatusEl: null,
    });
  }

  $onInit() {
    this.getVisits();
    this.Batching.getCategories(this.pagination.category_code)
      .then((categories) => {
        this.categories = categories;
        this.activeCategory = this.categories
          .filter(({ category_code }) => category_code === this.pagination.category_code);
      });
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };
    const callback = (entries) => {
      entries.forEach((entry) => {
        const visit = this.visits.find(thisVisit => thisVisit.id === parseInt(entry.target.id));
        if (visit) {
          if (entry.isIntersecting) {
            this.applyForSubscriptionToVisit(visit);
          } else {
            this.removeSubscriptionToVisit(false, visit);
          }
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
    this.$timeout(() => {
      const batch_rows = document.querySelectorAll('.batch-row');
      for (let i = 0; i < batch_rows.length; i++) {
        observer.observe(batch_rows[i]);
      }
    }, 100);
  }

  getVisits() {
    this.visits.forEach(visit => this.removeSubscriptionToVisit(false, visit));
    return this.Batching.getVisits(this.pagination)
      .then(({ visits, pagination }) => {
        this.pagination = {
          ...this.pagination,
          ...pagination,
        };
        this.visits = visits;
        this.batchCount = this.getBatchableVisits().length;
        this.visits.filter(visit => ![
          this.Batching.BatchingPhase.done,
          this.Batching.BatchingPhase.blocked,
          this.Batching.BatchingPhase.failed,
        ].includes(visit.status))
          .forEach(visit => this.applyForSubscriptionToVisit(visit));
        this.sortVisits();
        this.setupIntersectionObserver();
      })
      .catch((err) => {
      });
  }

  onPageChange() {
    this.getVisits();
  }

  onSortChange() {
    this.sortVisits();
  }

  search() {
    this.activeCategory = this.holdingSearchCategory;
    this.pagination.category_code = this.holdingSearchCategory[0].category_code;
    this.getVisits()
      .then(() => {
        this.updateBatchCount();
      });
  }

  getBatchableVisits() {
    return this.visits.filter((visit) => {
      return visit.batch.status === this.Batching.BatchingPhase.idle;
    });
  }

  changeServiceLevelBatchStatus() {
    this.categories
      .find(service => service.category_code === this.activeCategory[0].category_code)
      .batching_enabled = this.activeCategory[0].batching_enabled;
  }

  getVisitsMarkedForBatching() {
    return this.getBatchableVisits().filter(visit => visit.batch.shouldBatch);
  }

  updateBatchCount() {
    this.batchCount = this.getBatchableVisits()
      .filter(visit => visit.batch.shouldBatch)
      .length;
    this.updateBatchingStatusCheckbox();
  }

  toggleSelectAll() {
    const shouldBatch = this.batchCount !== this.getBatchableVisits().length;
    this.visits.forEach((visit) => {
      visit.batch.shouldBatch = shouldBatch;
    });
    this.updateBatchCount();
  }

  updateBatchingStatusCheckbox() {
    if (!this.checkboxStatusEl) {
      this.checkboxStatusEl = angular.element(document.querySelector('#batch-status_checkbox'));
    }
    this.checkboxStatusEl[0].indeterminate =
      this.batchCount !== this.getBatchableVisits().length
      && this.batchCount > 0;
  }

  sendForBatching() {
    this.Batching.processVisits(this.getVisitsMarkedForBatching());
  }

  applyForSubscriptionToVisit(visit) {
    if (!this.subscriptions.has(visit.id)) {
      this.Batching.subscribeToVisit(
        visit,
        this.updateVisitBatchStatus.bind(this),
        this.removeSubscriptionToVisit.bind(this, true)
      )
        .then((subscription) => this.subscriptions.set(visit.id, subscription));
    }
  }

  removeSubscriptionToVisit(animateRemoval, visit) {
    if (animateRemoval) {
      if ([
        this.Batching.BatchingPhase.done,
        this.Batching.BatchingPhase.blocked,
      ].includes(visit.batch.status)) {
        this.$timeout(() => this.removeVisit(visit), 10000);
      }
    }
    if (this.subscriptions.has(visit.id)) {
      const subscription = this.subscriptions.get(visit.id);
      subscription.unsubscribe();
      this.subscriptions.delete(visit.id);
    }
  }

  // TODO: rerun angularjs digest cycle more efficiently
  updateVisitBatchStatus(visit, batchUpdate) {
    visit.batch.status = batchUpdate.status;
    visit.batch.message = batchUpdate.message;
    this.$scope.$evalAsync(() => {
      this.sortVisits();
      this.updateBatchCount();
    });
  }

  sortVisits() {
    const priority = [
      this.Batching.BatchingPhase.done,
      this.Batching.BatchingPhase.blocked,
      this.Batching.BatchingPhase.failed,
      this.Batching.BatchingPhase.locked,
      this.Batching.BatchingPhase.idle,
      this.Batching.BatchingPhase.inProgress,
      this.Batching.BatchingPhase.queued,
    ];
    const modulator = this.pagination.order === "desc" ? -1 : 1;
    this.visits.sort((a, b) => {
      let bump = -1;
      if (priority.indexOf(a.batch.status) > priority.indexOf(b.batch.status)) {
        bump = 1;
      } else if (priority.indexOf(a.batch.status) === priority.indexOf(b.batch.status)) {
        if (this.pagination.sort === 'id') {
          if (a[this.pagination.sort] > b[this.pagination.sort]) {
            bump = 1 * modulator;
          }
        }
        if (this.pagination.sort === 'mail_order') {
          if (a.flags.mailorder > b.flags.mailorder) {
            bump = 1 * modulator;
          }
        }
      }
      return bump;
    });
  }

  removeVisit(visit) {
    this.visits = this.visits.filter(findVisit => findVisit.id !== visit.id);
  }

  markVisitUnbatchable(visit) {
    this.Batching.blockVisitFromBatching(visit);
  }

  openConfirmationWindow() {
    this.ngDialog.open({
      template: 'app/views/visits/list/tabs/batching/confirmation-modal/confirmation-modal.component.html',
      controller: 'BatchingConfirmationModalComponent',
      controllerAs: 'vm',
      data: {
        count: this.batchCount,
      },
      preCloseCallback: (res) => {
        if (res.approve) {
          this.sendForBatching();
        }
      },
    });
  }

  $onDestroy() {
    this.visits.forEach(visit => this.removeSubscriptionToVisit(false, visit));
  }
}

BatchingTableController.$inject = ['$rootScope', '$scope', '$timeout', 'Batching', 'Constants', 'ngDialog'];
angular.module('pims').component('batchingTable', {
  templateUrl: 'app/views/visits/list/tabs/batching/batching.component.html',
  controller: BatchingTableController,
  controllerAs: 'vm',
  bindings: {}
});
